import { render, staticRenderFns } from "./NavCategory.vue?vue&type=template&id=575e20a8&"
import script from "./NavCategory.vue?vue&type=script&lang=js&"
export * from "./NavCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports